<script>
  // import { onMount } from 'svelte';

  // import { animateScroll } from 'svelte-scrollto-element';

  // import FeedbackIntro from './pages/FeedbackIntro.svelte';
  // import FeedbackPageOne from './pages/FeedbackPageOne.svelte';
  // import FeedbackPageTwo from './pages/FeedbackPageTwo.svelte';
  // import FeedbackPageThree from './pages/FeedbackPageThree.svelte';
  // import FeedbackPageFour from './pages/FeedbackPageFour.svelte';
  // import FeedbackPageCompletion from './pages/FeedbackCompletion.svelte';

  let pageData = {
    intro: {
      index: 0,
      visible: false,
    },
    page1: {
      index: 1,
      visible: false,
    },
    page2: {
      index: 2,
      visible: false,
    },
    page3: {
      index: 3,
      visible: false,
    },
    page4: {
      index: 4,
      visible: false,
    },
    finish: {
      index: 5,
      visible: false,
    },
  };

  let finishTitle = 'Feedback Submitted';
  let finishBody =
    'Thank you for your feedback, it has been successfully submited and will be reviewed shortly.';

  // onMount(() => {
    // getHeight();
  // });

  let currPage;

  // currPage = localStorage.getItem('currentPage') ?? 'intro';
  // currPage = 'intro';

  if (currPage !== 'intro') {
    pageData[currPage].visible = true;
  } else {
    pageData['intro'].visible = true;
  }

  const feedback = {};

  // const changePage = (e) => {
  //   const nextPageVal = e.detail.page;
  //   const success = e.detail.feedbackSuccess ?? null;
  //   const currIndex = pageData[currPage].index;
  //   const nextIndex = pageData[nextPageVal].index;

  //   if (nextPageVal !== 'finish') {
  //     localStorage.setItem('currentPage', nextPageVal);
  //   } else {
  //     if (!success) {
  //       finishTitle = 'Submission Error';
  //       finishBody =
  //         'There was an issue submitting your feedback, please try again. If the problem persists please contact us and let us know.';
  //     }
  //   }

  //   currIndex < nextIndex ? nextPage(nextPageVal) : previousPage(nextPageVal);
  // };

  // const nextPage = (nextPageVal) => {
  //   // animateScroll.scrollToTop({element: '.feedback-wrapper', duration: 350 });
  //   pageData[currPage].visible = false;

  //   setTimeout(() => {
  //     currPage = nextPageVal;
  //     pageData[nextPageVal].visible = true;
  //     setTimeout(getHeight, 50);
  //     setTimeout(() => {
  //       pageData[nextPageVal].status = 'out';
  //     }, 1000);
  //   }, 200);
  // };

  // const getHeight = () => {
    // const container = document.querySelector('.feedback-wrapper');
    // const currentEl = document.querySelector('.feedback-el');
    // const height = currentEl.scrollHeight;
    // container.style.height = `${height}px`;
  // };
</script>

<div class="container">
  <div class="feedback-wrapper">
    <!-- {#if currPage === 'intro'} -->
      <!-- <FeedbackIntro
        on:changePage={changePage}
        visible={pageData.intro.visible} />
    {:else if currPage === 'page1'}
      <FeedbackPageOne
        on:changePage={changePage}
        visible={pageData.page1.visible} />
    {:else if currPage === 'page2'}
      <FeedbackPageTwo
        on:changePage={changePage}
        visible={pageData.page2.visible} />
    {:else if currPage === 'page3'}
      <FeedbackPageThree
        on:changePage={changePage}
        visible={pageData.page3.visible} />
    {:else if currPage === 'page4'}
      <FeedbackPageFour
        on:changePage={changePage}
        visible={pageData.page4.visible} />
    {:else if currPage === 'finish'}
      <FeedbackPageCompletion
        title={finishTitle}
        body={finishBody}
        visible={pageData.finish.visible} />
    {/if} -->
  </div>
</div>
